export default __webpack_public_path__ + "static/media/upgrade.ff2f67c3.png";